import { Pagination } from "@mui/material";

/**
 * Cursor-pagination footer for the audit list only.
 * Uses hasNextPage + nextToken (not a real total count).
 */
function AuditListPagination({
  page,
  rowsPerPage,
  rowCount,
  hasNextPage,
  onPageChange,
}) {
  const rangeStart = rowCount ? page * rowsPerPage + 1 : 0;
  const rangeEnd = rowCount ? page * rowsPerPage + rowCount : 0;
  const pageCount = hasNextPage ? page + 2 : Math.max(1, page + 1);
  const totalLabel = hasNextPage ? `${rangeEnd}+` : rangeEnd;

  return (
    <div className="pagination-wrap rda-pagination">
      <div className="pagination-wrap__meta">
        <p className="pagination-summary">
          Showing {rangeStart}-{rangeEnd} of {totalLabel}
        </p>
      </div>
      <Pagination
        page={page + 1}
        count={pageCount}
        color="primary"
        boundaryCount={1}
        siblingCount={1}
        onChange={(_event, newPage) => onPageChange(newPage - 1)}
      />
    </div>
  );
}

export default AuditListPagination;
